<ion-label [position]="labelPosition" *ngIf="to.label">
  {{ to.label }}
  <span
    *ngIf="to.required && to['hideRequiredMarker'] !== true"
    aria-hidden="true"
    >*</span
  >
</ion-label>
